if (!window.config) throw new Error("The environment file does not exist. Please run `node setup.js` to generate it.");

export const appConfig = window.config;
export const workloadConfig = window.workloadConfig;
